import React from 'react'

import FormContainer from '../../landing-form/form-container'
import { P0 } from '../p0'
import * as st from '../styles'
import BlackFridayHeroLine from '~/components/black-friday/hero-line'
import Breadcrumbs from '~/components/breadcrumbs'
import LandingForm from '~/components/landing-form/form-types/interactive'
import { LandingForm as RoundedLandingForm } from '~/components/landing-form/form-types/rounded'
import { PriceRiseHeroLine } from '~/components/price-rise-hero-line'
import { styles as themeStyles } from '~/styles/theme'

const ResultsHeroContent = ({
  postcode,
  onUpdate,
  currentProvider,
  headerText,
  headerImage,
  title,
  p0 = null,
  address,
  loading,
  criticalJs,
  children
}) => {
  const HERO_MIN_HEIGHT_MOBILE = 253
  const HERO_MIN_HEIGHT_DESKTOP = 420

  return (
    <>
      <Breadcrumbs />

      <div sx={st.row}>
        <div sx={{ ...st.column, minHeight: [HERO_MIN_HEIGHT_MOBILE, HERO_MIN_HEIGHT_DESKTOP], pb: ['md', 'xl'] }}>
          <div sx={st.copyContainer}>
            <BlackFridayHeroLine />

            <PriceRiseHeroLine />

            {children ? (
              <div sx={st.postcodeHero}>{children}</div>
            ) : (
              <div sx={st.packagesHeroContentStyles}>
                <h1 sx={themeStyles.h1}>{title}</h1>
                <p sx={st.postcodeHeroDescription}>{headerText}</p>
              </div>
            )}
          </div>

          <>
            {criticalJs ? (
              <FormContainer>
                <LandingForm variant='landing-form' providersUnderlay addressUnderlay />
              </FormContainer>
            ) : (
              <FormContainer customCss={st.formContainerStyle}>
                <RoundedLandingForm
                  customerAddress={address}
                  onUpdate={onUpdate}
                  provider={currentProvider}
                  isFetchingAddress={loading}
                />
              </FormContainer>
            )}
          </>
        </div>

        <P0
          address={address}
          p0={p0}
          postcode={postcode}
          currentProvider={currentProvider}
          headerImage={headerImage}
          hideImageWhilstLoading
        />
      </div>
    </>
  )
}

export default ResultsHeroContent
